<template>
    <spinner-until :condition="participantLoaded">
        <div class="home-participant">
            <div class="background-image-full"></div>
            <participant-menu>

                <div class="home__intro">
                    <h2>{{ $i18n.gt('HEADING_WELCOME') }}</h2>
                    <p>{{ $i18n.gt('LABEL_WELCOME_MESSAGE') }}</p>
                    <p class="mt-3">
                        <span>{{ $i18n.gt('LABEL_WELCOME_INSTRUCTIONS') }}</span>
                        <span class="help-button">
                            <b-icon-question-circle></b-icon-question-circle>
                        </span>
                    </p>

                    <b-alert show class="mt-3" variant="warning"
                             v-if="profileNotUpdated">
                        {{ $i18n.gt('MESSAGE_UPDATE_PROFILE') }}
                        <br/>
                        <b-btn size="sm" class="mt-3 float-right"
                               :to="`/participant/profile/id/${participant.id}`">
                            {{ $i18n.gt('LABEL_EDIT_PROFILE') }}
                        </b-btn>
                        <div class="clearfix"></div>
                    </b-alert>
                </div>
            </participant-menu>
        </div>
    </spinner-until>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>

import Vue from 'vue'
import PatientPageMixin from '@/providers/PatientPageMixin'

/**
 * Home page for participants/patients
 */
export default Vue.extend({
    name: 'HomeParticipant',
    mixins: [PatientPageMixin],
    computed: {
        profileNotUpdated() {
            return !!this.participant && !!this.participant.id && !this.participant.profile_updated
        }
    }
})

</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

@import '../../sass/base';

.home-participant {
    //display:flex;
    //justify-content: space-between;
    //align-items: flex-start;
}

.home__intro {
    position: relative;
    z-index: 1;
    background-color: #fff;
    padding: 2em;
    max-width: 600px;
    margin: 2em auto;

    p {
        font-size: 18px;
        margin-bottom: 0;
    }

    @media (min-width: 768px) {
        // @include absolute-center;
    }
}

.help-button {
    background: var(--base-color) !important;
    color: #fff !important;
    padding: 5px 5px 3px 5px;
    margin: 0 5px;
    border-radius: 5px;
    display: inline-block;
    svg {
        font-size: 30px !important;
    }
}

.background-image-full {

    position: absolute;
    z-index: 0;
    left: 0;
    top: 0;
    overflow: hidden;
    height: 100%;
    width: 100%;
    background-position: left top;
    background-repeat: no-repeat;

    @media (max-width: 480px) {
        @include opacity(.2);
        background-image: url(/../../images/consultant-phone.jpg);
        background-size: auto 100%;
        //padding-top: 100%;
    }

    @media (min-width: 481px) and (max-width: 767px) {
        //padding-top: 100%;
        @include opacity(.2);
        background-size: auto 100%;
    }

    @media (min-width: 768px) and (max-width: 1023px) {
        //padding-top: 55%;
        background-size: cover;
    }

    @media (min-width: 481px) and (max-width: 1023px) {
        background-image: url(/../../images/consultant-tablet.jpg);
        //padding-top: 100%;
    }

    @media (min-width: 1024px) {
        background-image: url(/../../images/consultant-desktop.jpg);
        background-size: cover;
        //padding-top: 43.9%;
    }

    @media (min-width: 1920px) {
        background-image: url(/../../images/consultant-wide.jpg);
    }


    /*
      <img srcset="/images/consultant-phone.jpg 480w,/images/consultant-tablet.jpg 1024w,/images/consultant-desktop.jpg 1920w,/images/consultant-wide.jpg 2560w"
      sizes="(max-width: 480px) 100vw, (max-width: 1024px) 100vw, (max-width: 1920px) 100vw, (max-width: 2560px) 100vw,"
      src="/images/consultant-wide.jpg" alt="">
    */

    @media (max-width: 767px) {
        //margin-left: -15px;
        //margin-right: -15px;
    }

    @media (min-width: 768px) {
        width: 100%;

        /*
              img {
                top: 0;
                @include horizontal-center;
                width: 100%;
                height: auto;
                @media (max-width: 767px) {
                  height: 100%;
                  width: auto;
                }
              }
              */
    }
}

</style>
